class FinishUpgradeModalComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-finish-upgrade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <h2 class="mb-4">Start a Subscription</h2>
              <div class="progress">
                <div class="progress-bar progress-bar-striped bg-default" role="progressbar" style="width: 50%"
                  aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">1.
                  Create account</div>
                <div class="progress-bar bg-default" role="progressbar" style="width: 50%" aria-valuenow="50"
                  aria-valuemin="0" aria-valuemax="100"><span class="text-light">2. Start subscription</span></div>
              </div>
            </div>
    
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center">
                      <h4>Basic</h4>
                    </th>
                    <th class="text-center">
                      <h4>Pro</h4>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><i class="fa fa-save fa-fw"></i> Save Projects</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-print fa-fw"></i> Print Results</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-ellipsis-h fa-fw"></i> More Bolt Patterns (more than 2x2)</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td><i class="fa fa-gears fa-fw"></i> Access Steel and Wood Beam Design Module</td>
                    <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
                    <td class="text-center"><i class="fa fa-check text-success"></i></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-center">Free</td>
                    <td class="text-center">$19 monthly</td>
                  </tr>
                </tbody>
              </table>
            </div>
    
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2 text-center text-primary">
                    <h1 class="text-primary">$19</h1>
                    <p>monthly</p>
                  </div>
                  <div class="col-md-10">
                    <form action="/charge" method="post" id="payment-form" role="form">
                      <h5 style="margin-bottom:20px;">
                        Enter credit or debit card information to upgrade
                      </h5>
                      <div id="card-element">
                        <!-- A Stripe Element will be inserted here. -->
                      </div>
    
                      <!-- Used to display Element errors. -->
                      <div id="card-errors" role="alert"></div>
    
                      <div id="subscribe-response-error" class="alert alert-danger d-none"></div>
                      <br>
                      <div class="d-grid gap-2">
                        <button id="submit-payment-button" type="button" class="btn btn-success btn-block">
                          <span id="submit-payment-spinner" class="spinner-border spinner-border-sm d-none"></span>
                          Submit Payment
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`
  }
}

customElements.define('finish-upgrade-modal-component', FinishUpgradeModalComponent);